import { g as i } from "../../utils-BOfnFgIH.js";
import { openBlock as l, createElementBlock as s, createElementVNode as t, createStaticVNode as c } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const d = {
  name: "DtIllustrationAtomicPathway",
  props: {
    /**
     * The label of the illustration as read out by a screenreader. Leave this unset if your illustration is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the illustrations migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-illustration";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = i();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], f = ["fill"], m = ["id"];
function p(a, r, o, h, k, e) {
  return l(), s("svg", {
    "aria-label": o.ariaLabel,
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    focusable: "false",
    role: "img",
    "data-name": "Atomic Pathway",
    class: "d-illustration d-illustration--atomic-pathway",
    width: "200",
    height: "200",
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    r[1] || (r[1] = t("circle", {
      cx: "74.9676",
      cy: "111.584",
      r: "57.5418",
      stroke: "var(--dt-color-surface-contrast)",
      "stroke-dasharray": "2 2"
    }, null, -1)),
    t("circle", {
      cx: "74.968",
      cy: "111.584",
      r: "35.4006",
      fill: `url(#${a.uniqueID}paint0_linear_1442_183)`
    }, null, 8, f),
    r[2] || (r[2] = c('<circle cx="5.82409" cy="5.82409" r="5.82409" transform="matrix(-1 0 0 1 186.643 50.2524)" fill="var(--dt-color-surface-contrast)"></circle><circle cx="5.82409" cy="5.82409" r="5.82409" transform="matrix(-1 0 0 1 44.8509 17.1189)" fill="var(--dt-color-surface-contrast)"></circle><circle cx="167.268" cy="157.963" r="6.17617" fill="var(--dt-color-surface-contrast)"></circle><circle cx="70.6146" cy="186.352" r="6.84948" fill="var(--dt-color-surface-contrast)"></circle><circle cx="100.088" cy="100.088" r="96.5883" stroke="var(--dt-color-surface-contrast)" stroke-dasharray="2 2"></circle><path d="M127.841 92.7378V111.349" stroke="var(--dt-color-surface-contrast)" stroke-width="2.27211" stroke-miterlimit="10"></path><path d="M118.533 102.046H137.144" stroke="var(--dt-color-surface-contrast)" stroke-width="2.27211" stroke-miterlimit="10"></path><path d="M121.256 95.4614L134.421 108.626" stroke="var(--dt-color-surface-contrast)" stroke-width="2.27211" stroke-miterlimit="10"></path><path d="M121.256 108.626L134.421 95.4614" stroke="var(--dt-color-surface-contrast)" stroke-width="2.27211" stroke-miterlimit="10"></path>', 9)),
    t("defs", null, [
      t("linearGradient", {
        id: `${a.uniqueID}paint0_linear_1442_183`,
        x1: "121.996",
        y1: "160.057",
        x2: "83.1019",
        y2: "63.6407",
        gradientUnits: "userSpaceOnUse"
      }, [...r[0] || (r[0] = [
        t("stop", {
          offset: "0.297344",
          "stop-color": "#7C52FF"
        }, null, -1),
        t("stop", {
          offset: "0.762314",
          "stop-color": "#F9008E"
        }, null, -1),
        t("stop", {
          offset: "1",
          "stop-color": "#F6AB3C"
        }, null, -1)
      ])], 8, m)
    ])
  ], 8, u);
}
const x = /* @__PURE__ */ n(d, [["render", p]]);
export {
  x as default
};
//# sourceMappingURL=atomic-pathway.js.map
